// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { Button } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/jsonMessages';
import { connect } from 'react-redux';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import { deleteListSettings } from '../../../actions/siteadmin/deleteListSettings';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import update from './update';
import validate from './validate';

import cp from '../../../components/commonStyle.css';
import s from './ListSettingsForm.css';
class EditListSettingsForm extends Component {

  static propTypes = {
    isEnable: PropTypes.string,
    id: PropTypes.number,
    typeId: PropTypes.number,
    fieldType: PropTypes.string,
    deleteListSettings: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      fieldType: null
    }
  }

  UNSAFE_componentWillMount() {
    const { fieldType } = this.props;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fieldType } = nextProps;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }

  handleDelete = async (id, typeId) => {
    const { deleteListSettings, adminListSettings, page, demoRestriction } = this.props;
    let currentPage = page > 1 && adminListSettings?.getAllAdminListSettings?.listSettingsData?.length == 1 ? page - 1 : page;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await deleteListSettings(id, typeId, currentPage)
  }

  handleUpdate = async (values, dispatch) => {
    const { page, searchListData } = this.props;
    await update(values, dispatch, page, searchListData)
  }

  render() {
    const { error, handleSubmit, submitting, title, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    const { id, typeId, deleteListSettings, listSettingsData, carModelListSettingsData } = this.props;
    const { fieldType } = this.state;
    let isListingData = listSettingsData && listSettingsData.listSettings;
    let isCarModelDetails = carModelListSettingsData && carModelListSettingsData.listSettings;

    return (
      <div>
        {title && <h1 className='siteAdminHeading'>{title}</h1>}
        <form onSubmit={handleSubmit(this.handleUpdate)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            {
              typeId && (typeId == 3) &&
              <Field
                name="makeType"
                disabled={true}
                type="text"
                inputClass='commonSelectField'
                component={CommonFormComponent}
                labelText={formatMessage(messages.makeLabel)}
                placeholder={formatMessage(messages.makeLabel)}
                isRequiredInput
              >
                {
                  isListingData && isListingData.length > 0 && isListingData.map((item, key) => {
                    if (item.isEnable == 1) {
                      return <option key={key} value={item.id}>{item.itemName}</option>
                    }
                  })
                }
              </Field>
            }

            <FieldArray
              name="dynamicItemName"
              component={FieldArrayComponent}
              selectedLanguage={selectedLanguage}
              fieldType={fieldType}
              typeId={typeId}
            />

            {
              fieldType == "numberType" &&
              <>
                <Field
                  name="startValue"
                  type="text"
                  inputClass='commonInputField'
                  component={CommonFormComponent}
                  labelText={formatMessage(messages.startValue)}
                  placeholder={formatMessage(messages.startValue)}
                />
                <Field
                  name="endValue"
                  type="text"
                  inputClass='commonInputField'
                  component={CommonFormComponent}
                  labelText={formatMessage(messages.endValue)}
                  placeholder={formatMessage(messages.endValue)}
                  isRequiredInput
                />
              </>
            }
            {
              fieldType != "numberType" &&
              <div>
                <div className='adminRadioBtn commonRadioBtnFlexGroup'>
                  <label className='commonRadioFlex'>
                    <Field name="isEnable" component="input" type="radio" value="1" />
                    <span className='siteAdminRadioText'>{formatMessage(messages.enableLabel)}
                    </span>
                  </label>

                  <label className='commonRadioFlex'>
                    <Field name="isEnable" component="input" type="radio" value="0" />
                    <span className='siteAdminRadioText'>{formatMessage(messages.disableLabel)}</span>
                  </label>
                </div>

                <div className={cx(cp.spaceTop4, 'doubleBtnFlexEnd')}>
                  <Button className={cp.btnPrimary} type="submit" disabled={submitting}>
                    {formatMessage(messages.update)}
                  </Button>
                  <Button className={cp.btnPrimaryBorder} onClick={() => this.handleDelete(id, typeId)} disabled={submitting}>
                    {formatMessage(messages.delete)}
                  </Button>
                </div>
              </div>
            }
          </div>
          {
            fieldType === "numberType" &&
            <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
              <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting}>
                {formatMessage(messages.update)}
              </Button>
            </div>
          }
        </form>
      </div>
    )
  }
}

EditListSettingsForm = reduxForm({
  form: "EditListSettingsForm", // a unique name for this form
  validate
})(EditListSettingsForm);

// Decorate with connect to read form values
const selector = formValueSelector("EditListSettingsForm"); // <-- same as form name

const mapState = (state) => ({
  isEnable: selector(state, 'isEnable'),
  id: selector(state, 'id'),
  typeId: selector(state, 'typeId'),
  listSettingsData: state?.adminListSettingsData?.isCarDetails,
  carModelListSettingsData: state?.adminListSettingsData?.isCarModelDetails,
  adminListSettings: state?.adminListSettingsData?.data,
  page: state?.adminListSettingsData?.currentPage,
  selectedLanguage: selector(state, 'dynamicItemName'),
  searchListData: state?.adminListSettingsData?.searchList,
});

const mapDispatch = {
  deleteListSettings,
  demoRestriction
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(EditListSettingsForm)));